import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email'
import '../assets/styles/Footer.scss'

function Footer() {
  return (
    <footer>
      <div>
        <a href="mailto:bludevllc@gmail.com"><EmailIcon/></a>
        <a href="https://www.linkedin.com/company/bludev-llc" target="_blank" rel="noreferrer"><LinkedInIcon/></a>
        <a href="https://github.com/fx-ha" target="_blank" rel="noreferrer"><GitHubIcon/></a>
      </div>
    </footer>
  );
}

export default Footer;
